export const UPDATE_PATH = 'UPDATE_PATH';
export const UPDATE_MULTIPLE_PATHS = 'UPDATE_MULTIPLE_PATHS';
export const SELECT_TAB = 'SELECT_TAB';
export const UPDATE_CORNER_PROPERTY = 'UPDATE_CORNER_PROPERTY';
export const UPDATE_REGION_TYPE = 'UPDATE_REGION_TYPE';
export const RESTORE_CLONED_VALUES = 'RESTORE_CLONED_VALUES';
export const UPDATE_CLONED_VALUES_AFTER_SAVE = 'UPDATE_CLONED_VALUES_AFTER_SAVE';
export const UPDATE_POSITION = 'UPDATE_POSITION';
